import React from 'react';
import { Grid } from '@material-ui/core';
import { Box } from '@material-ui/core';

const AdvancedLifeSkillsSchedule = () => {
  return (
    <Box sx={{ width: '100%' }}>
      <Grid container direction="row" align="left" style={{ margin: '5px 0' }}>
        <Grid item xs={4} sm={3} md={2}>
          Class #1
        </Grid>
        <Grid item xs={4} sm={3} md={2}>
          Wednesday, August 20th
        </Grid>
        <Grid item xs={4} sm={3} md={2}>
          6:30pm to 8:30pm
        </Grid>
      </Grid>
      <Grid container direction="row" align="left" style={{ margin: '5px 0' }}>
        <Grid item xs={4} sm={3} md={2}>
          Class #2
        </Grid>
        <Grid item xs={4} sm={3} md={2}>
          Wednesday, September 17th
        </Grid>
        <Grid item xs={4} sm={3} md={2}>
          6:30pm to 8:30pm
        </Grid>
      </Grid>
      <Grid container direction="row" align="left" style={{ margin: '5px 0' }}>
        <Grid item xs={4} sm={3} md={2}>
          Class #3
        </Grid>
        <Grid item xs={4} sm={3} md={2}>
          Thursday, October 23rd
        </Grid>
        <Grid item xs={4} sm={6} md={7}>
          9:00-11:00am during day (no school for students)
        </Grid>
      </Grid>
      <Grid container direction="row" align="left" style={{ margin: '5px 0' }}>
        <Grid item xs={4} sm={3} md={2}>
          Class #4
        </Grid>
        <Grid item xs={4} sm={3} md={2}>
          Thursday, November 20th
        </Grid>
        <Grid item xs={4} sm={3} md={2}>
          9:00-11:00am during day (no school for students)
        </Grid>
      </Grid>
      <Grid container direction="row" align="left" style={{ margin: '5px 0' }}>
        <Grid item xs={4} sm={3} md={2}>
          Class #5
        </Grid>
        <Grid item xs={4} sm={3} md={2}>
          Wednesday, December 10th
        </Grid>
        <Grid item xs={4} sm={3} md={2}>
          6:30pm to 8:30pm
        </Grid>
      </Grid>
      <Grid container direction="row" align="left" style={{ margin: '5px 0' }}>
        <Grid item xs={4} sm={3} md={2}>
          Class #6
        </Grid>
        <Grid item xs={4} sm={3} md={2}>
          Wednesday, January 14th
        </Grid>
        <Grid item xs={4} sm={3} md={2}>
          6:30pm to 8:30pm
        </Grid>
      </Grid>
      <Grid container direction="row" align="left" style={{ margin: '5px 0' }}>
        <Grid item xs={4} sm={3} md={2}>
          Class #7
        </Grid>
        <Grid item xs={4} sm={3} md={2}>
          Sunday, February 15th
        </Grid>
        <Grid item xs={4} sm={3} md={2}>
          6:30pm to 8:30pm
        </Grid>
      </Grid>
      <Grid container direction="row" align="left" style={{ margin: '5px 0' }}>
        <Grid item xs={4} sm={3} md={2}>
          Class #8
        </Grid>
        <Grid item xs={4} sm={3} md={2}>
          Wednesday, March 11th
        </Grid>
        <Grid item xs={4} sm={3} md={2}>
          6:30pm to 8:30pm
        </Grid>
      </Grid>
      <Grid container direction="row" align="left" style={{ margin: '5px 0' }}>
        <Grid item xs={4} sm={3} md={2}>
          Class #9
        </Grid>
        <Grid item xs={4} sm={3} md={2}>
          Wednesday, April 15th
        </Grid>
        <Grid item xs={4} sm={3} md={2}>
          6:30pm to 8:30pm
        </Grid>
      </Grid>
    </Box>
  );
};

export default AdvancedLifeSkillsSchedule;
